import * as React from "react";
import content from "../../content";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 25px;
  cursor: pointer;
`;

const Radio = styled.div<any>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: ${({ selected }) => (selected ? "#3f51b5" : "unset")};
  border: 1px solid #bebfc6;
`;

const Label = styled.div`
  margin-left: 7px;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;

  letter-spacing: -0.01em;

  color: #7a7c8b;

  @media (max-width: 1023px) {
    font-size: 12px;
  }
`;

export function RadioElement({ label, name, selected, onClick }: any) {
    return (
        <Wrapper onClick={onClick(name)}>
            <Radio selected={selected} />
            <Label>{content.getValue(label)}</Label>
        </Wrapper>
    );
}
